/**
 * Format filename used for PDF downloads
 */
export const formatPdfFileName = (name: string, { createdAt }: { createdAt?: string } = {}) => {
  const resolvedCreatedAt = createdAt || new Date().toISOString();

  return `${name}-${resolvedCreatedAt}`;
};
